// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__EwVYi","redes":"Footer_redes__98fJ+"};